import {useDispatch, useSelector} from "react-redux";
import {RootState} from "@/store";
import CreateInvitedUserForm from "@/components/formik/CreateInvitedUserForm.tsx";
import AuthLayout from "@/layout/AuthLayout.tsx";
import {useNavigate, useSearchParams} from "react-router-dom";
import {invite} from "@/store/modules/invite.ts";
import {VerifyInviteResponse} from "@/model/response/invite/VerifyInviteResponse.ts";
import {RouteConstant} from "@/util/constant/RouteConstant.ts";
import {useEffect, useState} from "react";

const InviteTeamMemberPage = () => {
    const dispatch = useDispatch<any>();
    const inviteState = useSelector((state: RootState) => state.invite);
    const [shouldCreateUser, setShouldCreateUser] = useState(false)
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()

    const inviteCode = searchParams.get("inviteCode");
    const verifyInviteCode = async (inviteCode: string) => {
        dispatch(invite.mutation.setLoading(true))
        const action = await dispatch(invite.action.verifyInvite({inviteId: inviteCode}));
        const response = action.payload as VerifyInviteResponse;
        dispatch(invite.mutation.setLoading(false))
        if (response?.responseCode == "01") {
            setShouldCreateUser(true);
        } else {
            navigate(RouteConstant.auth.login.path)
        }
    }

    useEffect(() => {
        if (inviteCode) {
            verifyInviteCode(inviteCode)
        } else {
            navigate(RouteConstant.auth.login.path)
        }
    }, [inviteCode]);

    if (shouldCreateUser) {
        return (
            <div style={{
                display: "flex",
                height: "100vh",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center"
            }}>
                <AuthLayout title={"Create an account"} subTitle={` Hi you've been invited to join the
                                workspace: ${inviteState?.verifiedInviteResponse?.workspaceName}`}>
                    <CreateInvitedUserForm/>
                </AuthLayout>
            </div>
        )
    }
    return <></>
}
export default InviteTeamMemberPage